import type { AgentScanType, Frequency, Target } from '@rtkwlf/rendall';

export interface FormSubmissionData extends ScanFrequencyFields {
  name: string;
  description: string;
  scannerId: string;
  targets?: string[] | Target[];
  scanTypes?: Array<AgentScanType>;
  autoEnroll?: boolean;
  agentTargets?: string[];
  scanningOutsideWindowDisabled?: boolean;
}

export interface ScanFrequencyFields {
  enabled: boolean;
  priority?: PriorityOptions;
  frequency: Frequency;
  scanTimeHourAndMinutes?: string;
  scanYear?: string;
  scanWindow?: string;
  scanWeeklyOnDay?: Array<boolean>;
  scanWeeklyOnDayAgent?: string;
  scanMonthlyOnDay?: string;
  scanMonth?: string;
  scanTime?: string;
  scanDate?: string;
  timezone: string;
}

export enum PriorityOptions {
  High = '1',
  Medium = '50',
  Low = '100',
}

export enum ScanWindowOptions {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  Seven = '7',
  Eight = '8',
  Nine = '9',
  Ten = '10',
  Eleven = '11',
  Twelve = '12',
}

export enum ScanEndOptions {
  OnThisDay = 'on this day',
  After = 'after',
  NoEndDate = 'no end date',
}

export enum FieldNames {
  Frequency = 'frequency',
  StartDate = 'startDate',
  EndDate = 'endDate',
  ScanWindow = 'scanWindow',
}

export enum MonthlyScanPositionTypes {
  First = 'first',
  Second = 'second',
  Third = 'third',
  Fourth = 'fourth',
  Last = 'last',
}

export enum MonthlyScanPositionDays {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Day = 'day',
  Weekday = 'weekday',
  Weekend = 'weekend day',
}

export enum ScanWindowMaxValues {
  DailyIvaAgent = 24,
  WeeklyIva = 168,
  MonthlyIva = 744,
  OnceWeeklyMonthlyAgent = 120,
}
